import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/app/PageHeader';
import { Card } from '@/components/ui/card';
import { fmtDate } from '@/lib/format';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  useEffect(() => { api.get('/audit-logs').then(r => setItems(r.data)); }, []);
  const filtered = q ? items.filter(i => JSON.stringify(i).toLowerCase().includes(q.toLowerCase())) : items;
  return (
    <div>
      <PageHeader title="Audit log" subtitle="Every change recorded for accountability" />
      <div className="mb-3 max-w-md relative">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input className="pl-8" placeholder="Search by user, action, entity…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search" />
      </div>
      <Card className="p-0 overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="bg-muted/60"><tr><th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">When</th><th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">User</th><th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Role</th><th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Action</th><th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Entity</th><th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Detail</th></tr></thead>
          <tbody>
            {filtered.map((a) => (
              <tr key={a.id} className="border-t hover:bg-muted/40">
                <td className="px-3 py-2 whitespace-nowrap">{fmtDate(a.created_at, 'dd MMM, HH:mm')}</td>
                <td className="px-3 py-2">{a.user_name}</td>
                <td className="px-3 py-2 capitalize">{a.role}</td>
                <td className="px-3 py-2 capitalize">{a.action}</td>
                <td className="px-3 py-2 font-mono text-xs">{a.entity}</td>
                <td className="px-3 py-2 text-muted-foreground">{a.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
